<template>
  <div
    class="modal-card"
    data-test="congrats-to-get-rewared--modal"
  >
    <img
      src="/static/img/reward-modal-close.png"
      class="modal-close-btn"
      @click="$emit('close')"
    >
    <div
      class="modal-body"
      data-test="congrats-to-get-rewared--modal-body"
      @click="$emit('close')"
    >
      <img src="/static/img/reward-modal-congrate.png">
      <p class="head-text">{{ $t('messages.congratulations') }}</p>
      <p class="token-amount">{{ $t('messages.you_have_got_kul', [tokenAmount]) }}</p>
      <p class="sub-title-text">{{ subTitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CongratsToGetReward',
  props: {
    tokenAmount: {
      type: Number,
      default: 0
    },
    subTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card {
  margin: 0 auto !important;
  max-width: 550px;
  max-height: 550px;
}
.modal-body {
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  img {
    display: inline-block;
  }
}
.modal-close-btn {
  margin-left: 87%;
  margin-bottom: 9px;
  object-fit: contain;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.head-text{
  position:absolute;
  left: 0;
  right: 0;
  top: 20%;
  text-align: center;
  color: #ffffff;
  font-size: 35px;
  font-weight: bold
}
.token-amount {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  color: #ffffff;
  font-size: 50px;
  font-weight: 900
}
.sub-title-text {
  position: absolute;
  left: 0;
  right: 0;
  top: 68%;
  color: #ffffff;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}
/* Mobile */
@media only screen and (max-width: 560px) {
  .modal-card {
    padding: 0 9px;
  }
  .head-text{
    font-size: 28px;
  }
  .token-amount {
    font-size: 8.2vw;
  }
  .sub-title-text {
    font-size: 3.5vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CongratsToGetReward.vue